import { render, staticRenderFns } from "./TabVerificaNote.vue?vue&type=template&id=0872c110&"
import script from "./TabVerificaNote.vue?vue&type=script&lang=js&"
export * from "./TabVerificaNote.vue?vue&type=script&lang=js&"
import style0 from "./TabVerificaNote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/TabVerificaNote.vue
// module id = 814
// module chunks = 0